import React, { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import MetaTags from "react-meta-tags";
import SelectList from "components/shared/select/select";
import ExcelDmae from "components/shared/excel/excel";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";



import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";

import Swal from "sweetalert2";
import api from "../../services/api";

const MonitorarMicros = () => {

const newdate = new Date();
  const dateFim = (newdate.toISOString().slice(0, 10));
newdate.setDate(newdate.getDate() - 700);
const dateIni = (newdate.toISOString().slice(0, 10));
  const initialState = {
    id: "",
    number: "",
    status: "",
    RGI_PRINCIPAL: "",
    DT_FILTER_INI: dateIni,
    DT_FILTER_FIM: dateFim,
  };

  const columnsLabel = {
    NR_ORDEM_SERVICO: "Ordem de Serviço",
    DT_ANO: "Dt. Ano",
    RGI_PRINCIPAL: "Principal/Macro medidor",
    NM_CONDOMINIO: "Nome Condomínio",
    CD_HIDROMETRO_IMOVEL: "Hidrometro Imóvel",
    CD_DISTRITO: "Distrito",
    CD_QUADRANTE: "Quadrante",
    CD_QUADRICULA: "Quadrícula",
    CD_SETOR: "Setor",
    CD_QUADRA: "Quadra",
    CD_LOTE_QUADRA: "Lote Quadra",
    CD_UNIDADE_LOTE: "Unidade Lote",
    CD_SERVICO: "Serviço",
    DS_SERVICO: "Descrição do Serviço",
    DT_BAIXA: "Data de Baixa",
    EXISTE_RETORNO: "Existe Retorno",
  }

  const [hydrometers, setHydrometers] = useState([]);
  const [values, setValues] = useState([]);
  const [search, setSearch] = useState(initialState);
  const [macro, setMacro] = useState({ value: "", label: "Selecione..." });
  const [showDownload, setShowDownload] = useState("none");
  const [excelData, setExcelData] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [load, setLoad] = useState(false);
  const [dataMicro,setDataMicro] = useState([]);
 
  const newHidros = () => {
    let body = {
      NR_HIDROMETRO_IMOVEL: search.number,
      RGI_PRINCIPAL: search.RGI_PRINCIPAL,
      DATA_INICIO: search.DT_FILTER_INI,
      DATA_FIM: search.DT_FILTER_FIM,
    };

    api.post("/monitoring/hydrometer", body).then((response) => {
      let arr = [];
      arr = formatArray(response.data);
      let excelArr = [];
      response.data.map((elem) => {
        excelArr.push({
          ...elem,
          EXISTE_RETORNO: elem.EXISTE_RETORNO == 0 ? "Pulso Normal" : "Pulso Travado",
        });
      });
      setExcelData(excelArr);
      setHydrometers(arr);
      setValues(arr);
    });
  }
  useEffect(() => {
    getMacro();

  }, []);

  const getConsumo = async (NR_HIDROMETRO) => {

    let body = {
      NR_HIDROMETRO: NR_HIDROMETRO,
      DT_FILTER_FIM: search.DT_FILTER_FIM,
      DT_FILTER_INI: search.DT_FILTER_INI,
      PAGE:1
    };
    setLoad(true);
    await api
      .post("/cdmndata/filter", body)
      .then((response) => {
        setDataMicro(response.data.reverse());
      });

    setLoad(false);
  }

  const getMacro = () => {
    api.get("/hydrometersmastercdmn/macro/0?FILTER=RGI").then((response) => {
      let data = [];
      let saneamento = [];
      response.data.map((elem) => {
        if (elem.NM_CONDOMINIO != null) {
          saneamento[elem.CD_LIGACAO_RGI_PRINCIPAL] = true;
        }
        if(elem.RGI_PRINCIPAL != null){
          data.push({
            value: elem.CD_LIGACAO_RGI_PRINCIPAL,
            label: elem.NM_CONDOMINIO != null ? elem.NM_CONDOMINIO : "SEM VINCULO COM SANEAMENTO - " + elem.CD_LIGACAO_RGI_PRINCIPAL,
            style: { color: elem.RGI_PRINCIPAL != null ? "Red" : "Black" },
          });
        }
      });
      if (data.length > 0) {
        setMacro(data);
        setShowDownload("Block");
      }else{
        setShowDownload("none");
      }
    })
  }

  const onSubmit = (event) => {
    event.preventDefault();
    let body = {
      NR_HIDROMETRO_IMOVEL: search.number,
     DATA_INICIO: search.DT_FILTER_INI,
      DATA_FIM: search.DT_FILTER_FIM,
      RGI_PRINCIPAL: search.RGI_PRINCIPAL,
    };

    api
      .post("/monitoring/hydrometer", body)
      .then((response) => {
        if (response.data.length === 0) {
          Swal.fire({
            icon: "warning",
            text: "Nenhum resultado encontrado, refaça a sua busca!",
          });
          setValues(hydrometers);
          setShowList(false);
        } else {
          Swal.fire({
            icon: "success",
            timer: 1000,
          });
          if(response.data.length > 0){
            setShowDownload("Block");
          }else{
            setShowDownload("none");
          }
          setValues(formatArray(response.data));
          let excelArr = [];
          response.data.map((elem) => {
            excelArr.push({
              ...elem,
              EXISTE_RETORNO: elem.EXISTE_RETORNO == 0 ? "Pulso Normal" : "Pulso Travado",
            });
          });
          setValues(formatArray(response.data));

          setExcelData(excelArr);
        }
      })
      .catch(function (error) {
        console.log(error);
        setValues(hydrometers);
      });
  };

  const onChangeHandler = (prop) => (event) => {
    setSearch({ ...search, [prop]: event.target.value });
  };

  const formatArray = (data) => {
    let arr = [];
    data.map((elem) => {
      arr.push({
        os: elem.NR_ORDEM_SERVICO,
        ano: elem.DT_ANO,
        hidrometro_imovel: elem.CD_HIDROMETRO_IMOVEL,
        principal_macro_medidor: elem.RGI_PRINCIPAL,
        nm_condominio: elem.NM_CONDOMINIO,
        servico: elem.CD_SERVICO,
        ds_servico: elem.DS_SERVICO,
        dt_baixa: elem.DT_BAIXA,
     });
    });
    return arr;
  };
 
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Monitoramento de Serviços</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Monitoramento de Serviços</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Bem vindo(a) ao IoT DMAE
                  </li>
                </ol>
              </Col>
            </Row>
          </div>
        </Container>
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <form onSubmit={onSubmit}>
                  <Row className="mb-3">
                    <label
                      htmlFor="RGI_PRINCIPAL"
                      className="col-md-2 col-form-label"
                    >
                      Principal/Macro medidor
                    </label>

                    <div className="col-md-6">

                      <SelectList
                        options={macro}
                        onOptionSelect={(handleOptionSelect) => {
                          console.log(handleOptionSelect);
                          setSearch({ ...search, RGI_PRINCIPAL: handleOptionSelect });
                        }}
                      />
                    </div>
                  </Row>
                  <Row className="mb-3">
                    <label htmlFor="codigo" className="col-md-2 col-form-label">
                      Número Hidrômetro Imóvel
                    </label>
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-lg"
                        type="text"
                        name="NR_HIDROMETRO"
                        value={search.number}
                        onChange={onChangeHandler("number")}
                      />
                    </div>
                  </Row>

                  <Row className="mb-3">
                    <div className="button-items text-center">
                      <Button
                        color="secondary"
                        className="btn-lg"
                        type="submit"
                      >
                        Pesquisar
                        <i className="dripicons-search" />
                      </Button>
                    </div>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Container fluid>

          <div style={{ display: showDownload, marginBottom: "5px" }} className="button-items">
              <ExcelDmae data={excelData} name="Monitorar Hidrômetros Micro" columns={columnsLabel} />
          </div>

          <div className="table-responsive">
            <table className="table align-middle table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="align-middle">Número OS</th>
                  <th className="align-middle">Ano</th>
                  <th className="align-middle">Principal/Macro medidor</th>
                  <th className="align-middle">Nome Condomínio</th>
                  <th className="align-middle">Hidrometro Imóvel</th>
                  <th className="align-middle">Cód. Serviço</th>
                  <th className="align-middle">Serviço</th>
                  <th className="align-middle">Dt. Baixa</th>
                  <th className="align-middle">Status</th>
                  <th className="align-middle"></th>

                </tr>
              </thead>
              <tbody>
                {values?.map((hydrometer, key) => (
                  <tr key={"_tr_" + key}>
                    <td>{hydrometer.os}</td>
                    <td>{hydrometer.ano}</td>
                    <td>{hydrometer.principal_macro_medidor}</td>
                    <td>{hydrometer.nm_condominio}</td>
                    <td>{hydrometer.hidrometro_imovel }</td>
                    <td>{hydrometer.servico}</td>
                    <td>{hydrometer.ds_servico}</td>
                    <td>{hydrometer.dt_baixa}</td>
                    <td class="d-inline-flex align-items-center">Pulsado Travado</td>
                    <td >
                       <i className={`dripicons-information text-danger align-middle`} 
                       title='O equipamento está enviando pulsos repetidos com o mesmo valor, sem incremento na leitura, indicando possível travamento ou ausência de consumo/leitura.' 
                        onClick={() => {
                          toggle();
                          getConsumo(hydrometer.hidrometro_imovel);
                          
                        }}
                       />
                    </td>
                                  
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>

        <Modal isOpen={modal} toggle={toggle} size="x">
          <ModalHeader
            color="primary"
            toggle={toggle}
            className="d-flex justify-content-center page-title"
          >
            {load ? (
              <>Aguarde...</>
            ) : (
              <>
                <h2 className="d-flex justify-content-center page-title">
                  Consumo Hidrômetros Micro
                </h2>
                <span className="d-flex justify-content-center page-title">
                 Últimos registros do micro selecionado:
                </span>
                  <table className="table align-middle table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="align-middle">Hidrômetro</th>
                      <th className="align-middle">Pulso</th>
                      <th className="align-middle">Dt. Leitura</th>

                    </tr>
                  </thead>
                  <tbody>
                        {dataMicro.length > 0 ? (
                          dataMicro.map((elem, key) => (
                            <>
                              <tr key={"_tr_" + key}>

                              <td>{elem.NR_HIDROMETRO_IMOVEL}</td>
                              <td>{elem.NR_PULSO}</td>
                              <td>{elem.DT_LEITURA}</td>
                            </tr>
                            </>
                          ))  
                          
                        ) : (
                          <tr>
                            <td colSpan={3}>Nenhum registro encontrado</td>
                          </tr>
                        )}
                  
                  </tbody>
                </table>
                    
              </>
            )}
          </ModalHeader>
          <ModalBody>
            {load ? (
              <>...</>
            ) : (
              <>
                <Row className="mb-3">
                  <Col md={12}>

                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter></ModalFooter>
        </Modal>
      </div>




    </React.Fragment >
  );
};

export default MonitorarMicros;
